import React from 'react'
import axios from 'axios'

import crefito from '../../assets/brasao.png'
import './AiView.css'

export default class AiView extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ficha: {} }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        var paf = id.slice(id.length - 3, id.length)
        const url = `/api/processo/getAi/${id}` 
        axios(url)
            .then(resp => {
                this.setState({ ficha: resp.data })

                if(paf == 'paf') {
                    var url2 = `/api/ficha/processo/${resp.data.processo}paf`
                } else {
                    var url2 = `/api/ficha/processo/${resp.data.processo}`
                }
                axios(url2)
                    .then(resp => {
                        this.setState({ list: resp.data })
                    })
                    .catch(error => {
                        alert(error.response.data)
                    }
                    )

            })
            .catch(error => {
                alert(error.response.data)
            }
            )
    }

    render() {
        return (
            <React.Fragment>
                <div className="container">
                    {this.renderAis()}
                </div>
            </React.Fragment>
        )
    }

    renderAis() {
        let select = []
        if (this.state.list) {
            let ano = this.state.ficha.data.slice(0, 4)
            let mes = this.state.ficha.data.slice(5, 7)
            let dia = this.state.ficha.data.slice(8, 10)
            let data = dia + "/" + mes + "/" + ano

            if (this.state.ficha.ai == 'Debito') {
                select.push(
                    <div className="col-12 text-center breakPaginaAiAntigo">
                        <div className="text-center">
                            <img src={crefito} alt="crefito" className="brasil mt-4" />
                        </div><br /><br />
                        <div className="col-12 mx-auto font-weight-bold text-center">
                            <div>SERVIÇO PÚBLICO FEDERAL</div>
                            <div className="mt-2">CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
                            <div className="mt-2">CREFITO-1</div>
                        </div>
                        <div className="caixaAiAntigo row mt-5">
                            <div className="col-12 mx-auto font-weight-bold text-center fundoAiAntigo">
                                <div className="mt-2">AUTO DE INFRAÇÃO</div>
                                <div className="mt-2">TERMO DE INTIMAÇÃO</div>
                                <div className="mt-2 mb-2">Nº {this.state.list.uf} {this.state.ficha.aiNumero}/{ano}</div>
                            </div>
                            <div className="col-6 text-left direitaAiAntigo">
                                <label className="col-3 font-weight-bold">AUTUADO(A):</label>
                                <label className="col-9">{this.state.ficha.autuado}</label>
                                <label className="col-5 font-weight-bold">Nº DE INSCRIÇÃO:</label>
                                <label className="col-7">{this.state.ficha.inscricao}</label>
                            </div>
                            <div className="col-6 text-left">
                                <label className="col-3 font-weight-bold">ENDEREÇO:</label>
                                <label className="col-9">{this.state.list.endereco}</label>
                                <label className="col-3 font-weight-bold">CIDADE:</label>
                                <label className="col-9">{this.state.list.municipio}</label>
                                <label className="col-3 font-weight-bold">ESTADO:</label>
                                <label className="col-9">{this.state.list.uf}</label>
                                <label className="col-3 font-weight-bold">CEP:</label>
                                <label className="col-9">{this.state.list.cep}</label>
                            </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>DESCRIÇÃO:</b> Identificado, através de levantamento financeiro do sistema cadastral deste Conselho
                                        Regional, que o (a) profissional supracitado (a) encontra-se em débito, com as obrigações pecuniárias,
                                        a seguir indicadas: Anuidades {this.state.ficha.anuidades}, (com os acrécimos legais);
                                        Multa eleitoral de {this.state.ficha.multa}; parcelamento das anuidades de {this.state.ficha.parcelamento}.
                            </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>NORMA INFRINGIDA:</b> Art. 15 e Art. 16, incisos I e VII da Lei 6.316/75 e Art. 9º, inciso VIII da
                                        Resolução COFFITO nº 424/2013.
                                    </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>NOTIFICAÇÃO:</b> O(a) profissional acima mencionado(a) fica notificado(a) a realizar as seguintes
                                        providências, no prazo de 10 (dez) dias úteis, a contar do recebimento deste documento: <b>Regularizar as
                                pendências pecuniárias junto ao CREFITO-1 ou apresentar defesa, conforme previsto no artigo 3º da Resolução
                                COFFITO 471/2016. Em caso de apresentação de defesa, deverá ser cumprindo o § 1º do Artigo 3º da Resolução
                                        COFFITO 471/2016, juntando-se as provas que Vossa Senhoria entender necessárias.</b>
                            </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>Sede do CREFITO-1:</b> {this.renderSede()}
                            </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>E-mail:</b> crefito1@crefito1.org.br
                                    </div>
                        </div>
                        <div className="col-12 text-right font-weight-bold mt-5">
                            {this.state.list.municipio}, {data}
                        </div>
                        <div className="row assinaturasAiAntigo mx-auto">
                            <div className="col-5 font-weight-bold text-center bordaAssinaturaAiAntigo">
                                Fiscal Técnico
                            </div>
                            <div className="col-2"></div>
                            <div className="col-5 font-weight-bold text-center bordaAssinaturaAiAntigo">
                                Profissional Responsável
                            </div>
                        </div>
                    </div>
                )
            }

            else if (this.state.ficha.ai == 'Branco') {
                select.push(
                    <div className="col-12 text-center breakPaginaAiAntigo">
                        <div className="text-center">
                            <img src={crefito} alt="crefito" className="brasil mt-4" />
                        </div><br /><br />
                        <div className="col-12 mx-auto font-weight-bold text-center">
                            <div>SERVIÇO PÚBLICO FEDERAL</div>
                            <div className="mt-2">CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
                            <div className="mt-2">CREFITO-1</div>
                        </div>
                        <div className="caixaAiAntigo row mt-5">
                            <div className="col-12 mx-auto font-weight-bold text-center fundoAiAntigo">
                                <div className="mt-2">AUTO DE INFRAÇÃO</div>
                                <div className="mt-2">TERMO DE INTIMAÇÃO</div>
                                <div className="mt-2 mb-2">Nº {this.state.list.uf} {this.state.ficha.aiNumero}/{ano}</div>
                            </div>
                            <div className="col-6 text-left direitaAiAntigo">
                                <label className="col-3 font-weight-bold">AUTUADO(A):</label>
                                <label className="col-9">{this.state.ficha.autuado}</label>
                                <label className="col-5 font-weight-bold">Nº DE INSCRIÇÃO:</label>
                                <label className="col-7">{this.state.ficha.inscricao}</label>
                            </div>
                            <div className="col-6 text-left">
                                <label className="col-3 font-weight-bold">ENDEREÇO:</label>
                                <label className="col-9">{this.state.list.endereco}</label>
                                <label className="col-3 font-weight-bold">CIDADE:</label>
                                <label className="col-9">{this.state.list.municipio}</label>
                                <label className="col-3 font-weight-bold">ESTADO:</label>
                                <label className="col-9">{this.state.list.uf}</label>
                                <label className="col-3 font-weight-bold">CEP:</label>
                                <label className="col-9">{this.state.list.cep}</label>
                            </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>DESCRIÇÃO:</b> {this.state.ficha.descricao}
                            </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>NORMA INFRINGIDA:</b> {this.state.ficha.norma}
                            </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>NOTIFICAÇÃO:</b> {this.state.ficha.notificacao}
                            </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>Sede do CREFITO-1:</b> {this.renderSede()}
                            </div>
                            <div className="col-12 text-left bordaTopoAiAntigo">
                                <b>E-mail:</b> crefito1@crefito1.org.br
                                    </div>
                        </div>
                        <div className="col-12 text-right font-weight-bold mt-5">
                            {this.state.list.municipio}, {data}
                        </div>
                        <div className="row assinaturasAiAntigo mx-auto">
                            <div className="col-5 font-weight-bold text-center bordaAssinaturaAiAntigo">
                                Fiscal Técnico
                            </div>
                            <div className="col-2"></div>
                            <div className="col-5 font-weight-bold text-center bordaAssinaturaAiAntigo">
                                Profissional Responsável
                            </div>
                        </div>
                    </div>
                )
            }
        }
        return select
    }

    renderSede() {
        if (this.state.list) {
            if (this.state.list.uf == 'PB') {
                return (
                    <React.Fragment>
                        Rua Geraldo Porto, 55 - Brisamar - João Pessoa/PB, CEP: 58033-020, Fone: (83) 3021-6900
                    </React.Fragment>
                )
            }
            else if (this.state.list.uf == 'AL') {
                return (
                    <React.Fragment>
                        Rua Dez de Novembro, 458 - Pitanguinha - Maceió/AL, CEP: 57052-220, Fone: (82) 3221-0756
                    </React.Fragment>
                )
            }
            else if (this.state.list.uf == 'RN') {
                return (
                    <React.Fragment>
                        Rua Acarí, 24 - Lagoa Nova - Natal/RN, CEP: 59063-280, Fone: (84) 3201-0607
                    </React.Fragment>
                )
            }
            else if (this.state.list.uf == 'PE') {
                return (
                    <React.Fragment>
                        Rua Henrique Dias, 303 - Boa Vista - Recife/PE, CEP: 50070-140, Fone: (81) 3081-5000
                    </React.Fragment>
                )
            }
        }
    }
}